import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Map = ({ onLoad, ...props }) => {
  useEffect(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1066"
    >
      <polygon
        data-floor="0"
        points="440.5 792.5 569 804 578.85 804 584 803 760 818 799 812 829 813 900 801 945 804 1024 789 1033.51 789 1041.11 789 1229 753 1248.25 753 1305 743 1305 785.73 1213 808 1197 807 997 862 983 860 829 902 440.5 859.05 440.5 792.5"
      />
      <polygon
        data-floor="1"
        points="440.5 792.5 578.85 804 584 803 760 818 799 812 829 813 900 801 945 804 1024 789 1041.11 789 1229 753 1248.25 753 1305 743 1312 741 1312 712.48 1303.89 712.48 1304 684 1246 688 1227 688 1041 705 1023 705 945 712 899 711 829 715 799 715 771 718 591 712 577 712 442 707 440.5 749.95 424 750 424 791.33 440.5 792.5"
      />
      <polygon
        data-floor="2"
        points="427 707 442 707 577 712 591 712 771 718 799 715 829 715 899 711 945 712 1023 705 1041 705 1227 688 1246 688 1304 684 1312 684 1312 678.13 1304 678.13 1304 626 937 621 899.8 621 830.1 621 799.32 621 681.53 621 444 621 444 665 427 665 427 707"
      />
      <polygon
        data-floor="3"
        points="431.82 621 444 621 569.42 621 666.63 621 748.79 621 830.1 621 899.8 621 937 621 1241.37 625.15 1304 626 1312 626 1312 597.84 1304.18 597.84 1304 568 1248 562 1223.23 562 1040 539 1020.4 539 939 531 899.36 531 831 526 800.38 526 757 523 446 538 446 581 429 581 429 621 431.82 621"
      />
      <polygon
        data-floor="4"
        points="433 538 446 538 477.85 536.46 554.22 532.78 608.38 530.17 728.11 524.39 757 523 800.38 526 831 526 899.36 531 939 531 1020.4 539 1040 539 1223.23 562 1248 562 1304 568 1310.99 568 1310.99 541.66 1304 541 1303 511 1248 498 1223.82 498 1040 458 1021.34 458 948 441 900 444 832 433 799.74 433 767 427 593 443 580 441 436 457 448 458 448 497.5 432 497.5 433 538"
      />
      <polygon
        data-floor="5"
        points="436 457 580 441 593 443 767 427 799.74 433 832 433 900 444 948 441 1021.34 458 1035.32 458 1040 458 1223.82 498 1248 498 1303 511 1312 511 1312 484.05 1304 484 1304 456 1244 435 1225 436 1039 376 1022.07 376 947 353 900 357 832 341 801.44 341 768 331 595 356 583 353 440 374 440 375 450 376 450 414 433 416 432 451 436 451 436 457"
      />
      <polygon
        data-floor="6"
        points="440 374 583 353 595 356 768 331 801.44 341 832 341 900 357 947 353 1022.07 376 1039 376 1225 436 1244 435 1304 456 1310.99 456 1310.99 432.08 1302 431 1302 400 1243 373 1224 374 1039 295 1022 296 945 264 900 271 832 248 801 250 766 237 598 268 583 265 441 292 441 293 450 296 451 332 440 333.93 440 374"
      />
      <polygon
        data-floor="7"
        points="441 292 583 265 598 268 766 237 801 250 832 248 900 271 945 264 1022 296 1039 295 1224 374 1243 373 1302 400 1302 345.21 1244 313 1225 315 1156 279 1156 264 1152 264 1152 261 950 153 888 165 881 165 868 159 866 161 855 155 855 151 837 144 780 153 768 147 599 186 586 182 443 215 443 220 448 220 449 249 439 249 441 292"
      />
    </svg>
  );
};

Map.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default Map;
